import { addKsql, getCollectionRailV2 } from '@kaltura-ott/tvpil';
import { lastValueFrom } from 'rxjs';

import { DEFAULT_PAGE_SIZE } from '../stores/category/widgets/rails/rail-store-helper-v2';
import { DmsStore } from '../stores/dms/dms-store';
import { EntitiesType } from '../stores/entities';
import { creatorEntityStore } from '../stores/entities/entities.service';
import { TransactionStore } from '../stores/transaction/transaction-store';

type GetCollectionDataArgs = {
  aggregatedKSQL: string;
  channelId: number;
  dmsStore: DmsStore;
  groupBy: string;
  orderBy: string;
  pageIndex: number;
  pageSize: number;
  transactionStore: TransactionStore;
};

// TODO: Remove this function after implementing search on queryClient.fetchQuery
export const getCollectionData = async ({
  aggregatedKSQL,
  channelId,
  dmsStore,
  groupBy,
  orderBy,
  pageIndex,
  pageSize,
  transactionStore,
}: GetCollectionDataArgs): Promise<{ newItems: EntitiesType[]; totalCount: number }> => {
  const kSql =
    transactionStore.isAdultEntitled || !dmsStore.dms.adultsConfigurations?.categoryReferenceId
      ? aggregatedKSQL
      : addKsql(aggregatedKSQL, `in_app_link!='${dmsStore.dms.adultsConfigurations?.categoryReferenceId}'`);

  const newRailData = await lastValueFrom(
    getCollectionRailV2({
      channelId,
      pageSize: DEFAULT_PAGE_SIZE,
      pageIndex,
      kSql,
      groupBy: groupBy,
      orderBy: orderBy,
    }),
  );
  return {
    newItems: newRailData.items.slice(0, pageSize).map((item) => creatorEntityStore(item)),
    totalCount: newRailData.totalCount,
  };
};
